import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../../api-services/login.service';
import { CommonService } from 'src/app/api-services/common.service';
import { MasterService } from 'src/app/api-services/master.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public isShowLoader = false;
  public isDealerLogin = false;
  public isPartLogin = false;
  public lang: any;
  public userName: any;
  public password: any;
  public dealer: any = {
    'lang': '',
    'LOGIN_ID': '',
    'PASSWORD': ''
  };
  public isDriveXLogin = false;
  public isDriveXPartsLogin = false;
  public isDriveXAccountsLogin = false;
  public isWebsiteImageLogin = false;
  public isDriveXProcurementLogin = false;
  public isDriveXApproval = false;
  public recentMenuList: any = [];
  constructor(
    private toastr: ToastrService,
    private httpClient: HttpClient,
    private loginService: LoginService,
    private router: Router,
    private masterService: MasterService) { }
  ngOnInit() {
    this.dealer.lang = "en";
  }

  login() {
    if (!this.isShowLoader) {
      this.isShowLoader = true;
      this.isDealerLogin = true;
      this.isDriveXLogin = false;
      if (this.dealer.LOGIN_ID == "partsorder@drivex.in") {
        this.isDriveXLogin = true;
        this.isPartLogin = true;
        this.isDriveXPartsLogin = true;
        this.isDriveXAccountsLogin = false;
        this.isDriveXProcurementLogin = false;
        this.isDriveXApproval = false;
      }else if(this.dealer.LOGIN_ID == "accounts@drivex.in"){
        this.isDriveXLogin = true;
        this.isDriveXPartsLogin = false;
        this.isDriveXAccountsLogin = true;
        this.isDriveXProcurementLogin = false;
        this.isDriveXApproval = false;
      }else if(this.dealer.LOGIN_ID == "websiteimage"){
        this.isDriveXLogin = true;
        this.isDriveXPartsLogin = true;
        this.isDriveXAccountsLogin = false;
        this.isDriveXProcurementLogin = false;
        this.isDriveXApproval = false;
      }else if(this.dealer.LOGIN_ID == "procurement@drivex.in"){
        this.isDriveXLogin = true;
        this.isDriveXPartsLogin = false;
        this.isDriveXAccountsLogin = false;
        this.isDriveXProcurementLogin = true;
        this.isDriveXApproval = false;
      }
      else if(this.dealer.LOGIN_ID === 'DTCApprover1@drivex.in' || this.dealer.LOGIN_ID === 'DTCApprover2@drivex.in' || this.dealer.LOGIN_ID === 'DTCApprover3@drivex.in'){
        this.isDriveXLogin = true;
        this.isDriveXPartsLogin = false;
        this.isDriveXAccountsLogin = false;
        this.isDriveXProcurementLogin = false;
        this.isDriveXApproval = true;
      }else if(this.dealer.LOGIN_ID == "OLXManagement"){
        this.isDriveXLogin = true;
        this.isDriveXPartsLogin = false;
        this.isDriveXAccountsLogin = false;
        this.isDriveXProcurementLogin = false;
        this.isDriveXApproval = false;
      }else if(this.dealer.LOGIN_ID == "SupportCallAdmin"){
        this.isDriveXLogin = true;
        this.isDriveXPartsLogin = false;
        this.isDriveXAccountsLogin = false;
        this.isDriveXProcurementLogin = false;
        this.isDriveXApproval = false;
      }else if(this.dealer.LOGIN_ID == "BulkUploadVehicle"){
        this.isDriveXLogin = true;
        this.isDriveXPartsLogin = false;
        this.isDriveXAccountsLogin = false;
        this.isDriveXProcurementLogin = false;
        this.isDriveXApproval = false;
      }
      else if(this.dealer.LOGIN_ID == "BulkUploadParts"){
        this.isDriveXLogin = true;
        this.isDriveXPartsLogin = false;
        this.isDriveXAccountsLogin = false;
        this.isDriveXProcurementLogin = false;
        this.isDriveXApproval = false;
      }
      this.masterService.get('', '/Dealer/DealerMasterLogInCred?UName=' +
        this.dealer.LOGIN_ID + '&Password=' + this.dealer.PASSWORD)
        .subscribe(
          (resp: any) => {
            if (resp.statusCode == 200) {
              this.toastr.success(resp.statusMessage);
              this.recentMenuList = [];
              localStorage.setItem('langId', this.dealer.lang);
              this.httpClient.get('assets/i18n/' + this.dealer.lang + '.json').subscribe(
                langResp => {
                  localStorage.setItem('lang', JSON.stringify(langResp));
                  localStorage.setItem('isDealerLogin', JSON.stringify(this.isDealerLogin));
                  localStorage.setItem('isDriveXLogin', JSON.stringify(this.isDriveXLogin));
                  localStorage.setItem('isDriveXPartsLogin', JSON.stringify(this.isDriveXPartsLogin));
                  localStorage.setItem('isDriveXAccountsLogin', JSON.stringify(this.isDriveXAccountsLogin));
                  localStorage.setItem('isDriveXProcurementLogin', JSON.stringify(this.isDriveXProcurementLogin));
                  localStorage.setItem('isDriveXApproval', JSON.stringify(this.isDriveXApproval));

              if (this.dealer.LOGIN_ID == "partsorder@drivex.in") {
                localStorage.setItem('isPartLogin', JSON.stringify(this.isPartLogin));
                // this.router.navigate(['/parts/purchase-order-list/drivex-purchase-order-list']);
                this.router.navigate(['/parts/purchase-order-list/dealer-purchase-order-list']);
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
              }
              else if (this.dealer.LOGIN_ID == "accounts@drivex.in") {
                localStorage.setItem('isPartLogin', JSON.stringify(false));
                this.router.navigate(['/parts/purchase-order-list/dealer-purchase-order-list']);
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
              }
              else if(this.dealer.LOGIN_ID == "dealeronboarding"){
                this.recentMenuList = [];
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
                this.router.navigate(['admin/dealer-onboard-list']);
              }
              else if(this.dealer.LOGIN_ID == "websiteimage"){
                this.recentMenuList = [];
                this.router.navigate(['/uvd/uvd-sales/website-image-ordering']);
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
              }else if(this.dealer.LOGIN_ID == "procurement@drivex.in"){
                this.recentMenuList = [];
                this.router.navigate(['/admin/pricing-grid-list']);
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
              }
              else if(this.dealer.LOGIN_ID === 'DTCApprover1@drivex.in' || this.dealer.LOGIN_ID === 'DTCApprover2@drivex.in' || this.dealer.LOGIN_ID === 'DTCApprover3@drivex.in'){
                this.recentMenuList = [];
                localStorage.setItem('isDriveXLogin', 'true');
                localStorage.setItem('userId', this.dealer.LOGIN_ID);
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
                this.router.navigate(['uvd/refurbishment/refurbishment-approval-list']);
              }
              else if(this.dealer.LOGIN_ID == "OLXManagement"){
                this.recentMenuList = [];
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
                this.router.navigate(['/uvd/uvd-sales/vehicle-listing-page']);
              }
              else if(this.dealer.LOGIN_ID == "SupportCallAdmin"){
                this.recentMenuList = [];
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
                this.router.navigate(['/call-log/admin-support-call-list']);
              }
              else if(this.dealer.LOGIN_ID == "BulkUploadVehicle"){
                this.recentMenuList = [];
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
                this.router.navigate(['admin/vehicle-bulk-upload-list']);
              }
              else if(this.dealer.LOGIN_ID == "BulkUploadParts"){
                this.recentMenuList = [];
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
                this.router.navigate(['admin/part-bulk-upload-list']);
              }
              else {
                this.recentMenuList = [];
                localStorage.setItem('recentMenu', JSON.stringify(this.recentMenuList));
                this.router.navigate(['admin/dealer-master']);
              }
            });
          }
            if (resp.statusCode == 401) {
              this.toastr.error(resp.statusMessage);
            }
            this.isShowLoader = false;
          }, error => {
            if (error.status == 401) {
              this.loginService.logout();
            }
            this.isShowLoader = false;
            this.toastr.error(error.statusText);
          }
        )
    }
  }
}
